module.exports = {
  dimensions: {
    width: 194,
    height: 60
  },
  optical: {
    top: 0,
    left: 0,
    right: 1,
    bottom: 1
  }
};